import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { amplitude_tracking } from 'helpers/amplitudeTracking';

const useTracking = () => {
  useEffect(() => {
    // Initialize Sentry
    Sentry.init({
      dsn:
        'https://3c7dcb320f67c6247aefb17f41c03901@o469049.ingest.us.sentry.io/4507823094693888',
      environment: process.env.NODE_ENV,
      enabled: process.env.NODE_ENV === 'production',
      autoSessionTracking: false,
      defaultIntegrations: false,
      release: 'sofabuddy'
    });

    if (window.Sofatutor.consentGivenForCategory('analytics')) {
      Sentry.setUser({ id: window.Sofatutor.user.id });
    }
  }, []);

  // Provide the amplitudeTracking function
  const amplitudeTracking = (eventName, data) => {
    amplitude_tracking(eventName, data);
  };

  // Provide a function to capture exceptions
  const captureException = error => {
    Sentry.captureException(error);
  };

  return { amplitudeTracking, captureException };
};

export default useTracking;
